import { useEffect, useState } from "react";

/**
 * Draft-only pages: visible in Lovable preview and local dev, hidden (404) on the
 * published production sites. Used to archive pages without deleting the work.
 */

/** Hosts where the published, public site is served. */
const PUBLISHED_HOSTS = [
  "crsenergy.org",
  "www.crsenergy.org",
  "completeremedialsolutions.co.uk",
  "www.completeremedialsolutions.co.uk",
  "crsenergy.lovable.app",
];

export function isDraftVisibleForHost(host: string | null | undefined): boolean {
  if (!host) return true;
  const hostname = host.split(":")[0]!.toLowerCase();
  return !PUBLISHED_HOSTS.includes(hostname);
}

/** Works on both the server (request host) and the client (window.location). */
export function isDraftVisible(): boolean {
  if (typeof window !== "undefined") {
    return isDraftVisibleForHost(window.location.hostname);
  }
  return true;
}

/** SSR-safe: false during server render, so draft links never appear in published HTML. */
export function useDraftVisible(): boolean {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(isDraftVisible());
  }, []);
  return visible;
}
